// @ts-nocheck
import range from 'lodash/range';
import React from 'react';
import { Option, Select } from './../ant/Select';
const years = range(new Date().getFullYear(), 1979);
// Выпадающий список годов выпуска ТС
export default class YearIssueSelect extends React.Component {
  state = {
    years: years
  };
  handleSearch = value => {
    this.setState({
      years: years.filter(year => year.toString().includes(value))
    });
  };
  render() {
    const {
      years
    } = this.state;
    return <Select onSearch={this.handleSearch} showSearch placeholder="Выберите год выпуска ТС" allowClear {...this.props}>
        {years.map(year => <Option value={year} key={year}>
            {year} год
          </Option>)}
      </Select>;
  }
}
